import React from 'react';
import { ListClinicResponseElement } from '../../../types/apiGeneratedTypes';
import TableRowActionMenu from '../../BaseComponents/TableRowActionMenu';
import { useDispatch } from 'react-redux';
import {
  changeModalVisibility,
  setClinicDataToEdit,
  setClinicDataToView
} from '../../../store/clinicsSlice';

type Props = {
  clinicData: ListClinicResponseElement;
};

const DoctorsTableRow = ({ clinicData }: Props) => {
  const dispatch = useDispatch();

  const onOptionClick = async (id: number, action: string) => {
    if (action === 'edit') {
      dispatch(setClinicDataToEdit(clinicData));
      dispatch(changeModalVisibility(true));
    }
    
    if (action === 'view') {
      dispatch(setClinicDataToView(clinicData));
    }
  };
  return (
    <div className='table-row'>
      <div className='name'>{clinicData.title}</div>
      <div className='address'>{clinicData.address}</div>
      <div className='url'>{clinicData.maps_link}</div>
      <div className='contacts'>
        <span>{clinicData.email}</span> <span>{clinicData.phone}</span>
      </div>
      <div className='desc'>{clinicData.description}</div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit' },
            { key: 'view', value: 'View' },
            // { key: 'delete', value: 'Delete' },
          ]}
          id={clinicData.email}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default DoctorsTableRow;
